import { InputBase, styled } from '@mui/material';

export const StyledInputBase = styled(InputBase)(({ value }) => ({
  height: 32,
  position: 'relative',
  padding: '5.585px 24px 5.585px 8px',
  borderRadius: 4,
  border: '1px solid #828D98',
  fontSize: 13,
  backgroundColor: '#fff',

  '&.MuiInputBase-root': {
    marginTop: 0,
  },

  '&.Mui-focused': {
    outline: '2px solid #0175C9',
    outlineOffset: '2px',
    borderRadius: 4,
    backroundColor: 'unset',
  },

  '&.Mui-disabled': {
    backgroundColor: '#F9F9FA',
    borderColor: '#D8DBDF',
  },

  '& .MuiInputBase-input.Mui-disabled': {
    WebkitTextFillColor: '#B1B8BF',
  },

  '&.Mui-readOnly': {
    borderColor: 'transparent',
  },

  '&.Mui-error': {
    borderColor: '#D82C0D',
  },

  '& .MuiSelect-select': {
    color: value ? '#292D35' : '#828D98',
    '&:focus': {
      backgroundColor: 'unset',
    },
  },
}));
